import { Component, Inject, OnInit } from '@angular/core';

// Icons
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { Ranking } from '../ranking/interfaces/ranking';
import { RankingDataService } from '../ranking/services/ranking-data.service';
import { WINDOW } from '@shared/services/window.service';

import { environment } from 'environments/environment';

@Component({
  selector: 'home-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  standalone: false
})
export class HomepageComponent implements OnInit {

  environment = environment;
  rankings: Ranking[] = [];

  // Icons
  faSpinner = faSpinner;

  // Progress
  errorReading: string | null = null;
  isReading = false;

  constructor(
    private rankingDataService: RankingDataService,
    @Inject(WINDOW) private window: Window | null
  ) { }

  ngOnInit() {
    this.read();
  }

  goProfile(studentId: number) {
    if (this.window) {
      this.window.open('/profile?s=' + studentId, '_blank');
    }
  }

  private processRankings(value) {

    // Store the rankings
    this.rankings = value.slice(0, 10);

    // Process values
    this.rankings.forEach(ranking => {
      if (ranking.State === '-') {
        ranking.State = null;
      }

      ranking.Location = ranking.Country + (ranking.State ? ', ' + ranking.State : '');
    });
  }

  private read() {

    if (this.isReading) {
      return;
    }

    // Show spinner
    this.isReading = true;

    // Reset error status
    this.errorReading = null;

    // Read the ranking data
    this.rankingDataService.read()
      .subscribe(
        (value) => {

            this.processRankings(value);

            // Hide spinner
            this.isReading = false;
        },
        (error) => {
            this.errorReading = error;
            this.isReading = false;
        }
      );
  }
}
